import React, { useState } from "react";

const StripeInput = React.forwardRef(function StripeInput(props, ref) {
  // @ts-ignore
  const { component: Component, options, ...other } = props;
  const [mountNode, setMountNode] = useState();

  // @ts-ignore
  React.useImperativeHandle(
    ref,
    () => ({
      focus: () => mountNode && mountNode?.focus(),
    }),
    [mountNode]
  );

  return <Component onReady={setMountNode} {...other} />;
});

export default StripeInput;
